class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.classList.contains('active')) {
        this.close();
        return
      }
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        if (this.classList.contains('active')) {
          this.close();
          return
        }
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {

    this.headerdraw = this.headerdraw || document.querySelector('sticky-header header-drawer');
    this.headerdrawdetails = this.headerdrawdetails || this.headerdraw.querySelector('details');
    if (this.headerdrawdetails.classList.contains('menu-opening')) {
        this.headerdraw.closeSubmenu(this.headerdrawdetails);
        this.headerdraw.closeMenuDrawer(new PointerEvent("keydown"), this);
    }

    if (window.autoLenis) window.autoLenis.stop();

    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.header.querySelector('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    if (typeof window.updateHeaderBottomPosition === 'function') window.updateHeaderBottomPosition();
    this.header.classList.add('menu-open');

    let cartItems = this.querySelector('cart-items') || this.querySelector('cart-drawer-items');
    if (cartItems) {
        cartItems.whyNotBuy();
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('cart-drawer-open');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('cart-drawer-open');
    this.header.classList.remove('menu-open');
    if (window.autoLenis) window.autoLenis.start();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    let cartItems = this.querySelector('cart-items') || this.querySelector('cart-drawer-items');
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (cartItems) {
        cartItems.whyNotBuy();
      }
    });

    if (cartItems) {
        cartItems.whyNotBuy();
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartSWitcher extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(evt) {
    evt.preventDefault();
    
    const cartItems = this.closest('cart-drawer-items');


    if (!cartItems) {
      console.error('Cart items not found.');
      return;
    }
    
    let cartDrawerWNBLS = (localStorage.getItem('cartDrawerWNB')) ? JSON.parse(localStorage.getItem('cartDrawerWNB')) : '';
    if (!cartDrawerWNBLS || cartDrawerWNBLS.expires < Date.now()) {
        cartDrawerWNBLS = {
            data: '',
            expires: Date.now() + window.cartWNBtimeout,
        };
        localStorage.setItem('cartDrawerWNB', JSON.stringify(cartDrawerWNBLS));
    }
    
    let prodVar = this.getAttribute('data-product') + '-' + this.getAttribute('data-variant');
    
    cartDrawerWNBLS.data = cartDrawerWNBLS.data + ',' + prodVar;
    cartDrawerWNBLS.expires = Date.now() + window.cartWNBtimeout;


    // add to cart
    this.cart = document.querySelector('cart-drawer');
    
    this.setAttribute('aria-disabled', true);
    this.classList.add('loading');
    document.querySelector('.cart-drawer .cart-item > td + td.cart-why-not-buy.fully.shown .loading__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('form_type', 'product');
    formData.append('utf8', '✓');
    formData.append('id', this.dataset.variant);
    formData.append('product-id', this.dataset.product);
    formData.append('add', 'Add to Basket');
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    cartItems.updateQuantity(this.dataset.index, (this.dataset.quantity - 1));

    let waitTillUpdate = setInterval(() => {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        if (!mainCartItems.classList.contains('cart__items--disabled')) {
            clearInterval(waitTillUpdate);

            fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
            if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.setAttribute('aria-disabled', true);
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
            } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
            }

            if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
                });

                localStorage.setItem('cartDrawerWNB', JSON.stringify(cartDrawerWNBLS));
            this.error = false;
            this.cart.renderContents(response);
            })
            .catch((e) => {
            console.error(e);
            })
            .finally(() => {
            this.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
            });
        }
    }, 100);
  }
  handleErrorMessage(errorMessage = false) {

    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

customElements.define('cart-switcher', CartSWitcher);

